import { motion, useTransform, MotionValue } from 'framer-motion';
import { ANIMATION_CONFIG } from './constants';

interface MergedCardProps {
  scrollYProgress: MotionValue<number>;
}

export const MergedCard: React.FC<MergedCardProps> = ({ scrollYProgress }) => {
  // Fade in during merge phase, then stay visible
  const opacity = useTransform(
    scrollYProgress,
    [
      ANIMATION_CONFIG.fadeInMergedCard[0],
      ANIMATION_CONFIG.fadeInMergedCard[1],
    ],
    [0, 1]
  );

  // Scale up on entry
  const scale = useTransform(
    scrollYProgress,
    [
      ANIMATION_CONFIG.fadeInMergedCard[0],
      ANIMATION_CONFIG.fadeInMergedCard[1],
    ],
    [0.9, 1.0]
  );

  return (
    <motion.div
      className="absolute left-1/2 top-[40%]"
      style={{
        x: 'calc(0vw - 50%)',
        y: 'calc(0vh - 50%)',
        opacity,
        scale,
      }}
      initial={{ opacity: 0 }}
    >
      <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-2xl shadow-2xl overflow-hidden bg-card border">
        {/* Card content */}
        <div className="relative w-full h-full backdrop-blur-sm rounded-2xl flex flex-col items-center justify-center gap-4">
          {/* Logo */}
          <img
            src="/media/tag-innovation-logo.png"
            alt="Tag-Inn Logo"
            className="w-20 h-20 md:w-24 md:h-24 object-contain"
          />

          {/* Brand name */}
          <div className="text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight">
              Tag-Inn
            </h3>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
